import { useState, useCallback, useEffect } from "react";
import { isEqual } from "lodash";

import { MailInboxOptionValue, MailInboxQuickFilter } from "./interfaces";

import { MailInboxDTO } from "src/models/mail-inbox";
import { useAppSelector } from "src/custom-hooks/redux/redux";

const LOCAL_STORAGE_IDENTIFIER = "QF_MI";
export const useMailInboxQuickFilter = () => {
  const { currentUserAuthorizations } = useAppSelector((state) => state.currentUserReducer);
  const allowedMailInboxes = currentUserAuthorizations?.allowedMailInboxes?.flatMap(
    (allowedMailInbox) => allowedMailInbox.key
  );

  const [quickFilter, setQuickFilter] = useState<MailInboxQuickFilter>({
    mailInboxes: {
      mailInboxIds: [],
    },
  });

  const [selectedMailInbox, setSelectedMailInbox] = useState<MailInboxDTO | null>(null);

  useEffect(() => {
    const previousLocalStorageValue = localStorage.getItem(LOCAL_STORAGE_IDENTIFIER);
    let previousValue: MailInboxDTO | null = previousLocalStorageValue ? JSON.parse(previousLocalStorageValue) : null;
    if (previousValue) {
      const previousValueAllowed = allowedMailInboxes?.includes(previousValue.id) ? previousValue : null;
      if (previousValueAllowed) {
        setQuickFilter({
          mailInboxes: {
            mailInboxIds: [previousValue.id],
          },
        });
        setSelectedMailInbox(previousValue);
      }
    }
  }, []);

  const handleChangeQuickFilter = useCallback(
    (filter: keyof MailInboxQuickFilter, value: MailInboxQuickFilter["mailInboxes"], item: MailInboxDTO | null) => {
      if (isEqual(value, quickFilter[filter])) return;

      setQuickFilter((state) => ({ ...state, [filter]: value }));
      setSelectedMailInbox(item);

      localStorage.setItem(LOCAL_STORAGE_IDENTIFIER, JSON.stringify(item));
    },
    [quickFilter]
  );

  return {
    mailInboxQuickFilter: quickFilter,
    setMailInboxQuickFilter: handleChangeQuickFilter,
    selectedMailInbox: selectedMailInbox,
  };
};
